import React, {Component, Fragment} from 'react';
import './TaskGroupTrainingDetails.scss';
import TaskResponseHeader from "./TaskResponseHeader";
import TaskResponseForm from "./TaskResponseForm";
import TaskResponseRow from "./TaskResponseRow";
import {Card, CardBody, Collapse} from 'reactstrap';
import {connect} from "react-redux";
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import classNames from 'classnames'
import Modal from "../../../shared/ui/Modal";
import CustomForm from "../../../shared/components/form/CustomForm";
import {taskAddCommentForm} from "../../../shared/components/form/TaskFormConfig";

let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});

const incrementReferenceMaterial = (value) => {
  if (value) {
    return value + 1
  }
  return 1;
}

const decrementReferenceMaterial = (value) => {
  if (value && value > 0) {
    return value - 1
  }
  return 0;
}

class TaskGroupTrainingDetails extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isAddCommentOpened: false,
      currentAddCommentIndex: null,
      editingCommentIndex: null
    }
  }

  getReferenceMaterialSplit(referenceMaterial, taskGroup) {
    let {onReferenceMaterialUpdate} = this.props
    let referenceResponses = taskGroup.reference_responses || {}

    if (referenceMaterial) {
      console.log('REFERENCE MATERIAL SPLIT', referenceMaterial.split(/\r?\n/))
      return referenceMaterial.split(/\r?\n/)
        .map((c, index) => (
          <Fragment key={index + 'fragment'}>
            <div
              key={index + 'action-buttons'} className={classNames({
              "reference-material-row": true,
              completed: !!referenceResponses[index],
              failed: referenceResponses[index] === false
            })}
            >
              {!!c && <div className="action-buttons">
                {!referenceResponses[index] &&
                  <div className={classNames({'action-button': true, selected: !!referenceResponses[index]})}
                       onClick={() => onReferenceMaterialUpdate(taskGroup.taskGroupTrainingTrackerGuid, index, true)}>Mark
                    as complete
                  </div>}
                {!!referenceResponses[index] &&
                  <div className={classNames({'action-button': true, selected: !referenceResponses[index]})}
                       onClick={() => onReferenceMaterialUpdate(taskGroup.taskGroupTrainingTrackerGuid, index, null)}>Unmark
                    as complete
                  </div>}

                {/*<div className={classNames({'action-button': true, selected: referenceResponses[index] === false})}  onClick={() => onReferenceMaterialUpdate(index, false)}>Mark as failed</div>*/}
              </div>}
              {(referenceResponses[`O${index}`] || referenceResponses[`P${index}`]) &&
              <div className="reference-material-op">
                <span>Observed ({referenceResponses[`O${index}`] || 0}) </span>
                <span>Practiced ({referenceResponses[`P${index}`] || 0})</span>
              </div>
              }
              {c}
            </div>
            {referenceResponses[`C${index}`] && referenceResponses[`C${index}`].map((c, i) => (
              <div key={index + "C" + i} title="Edit" className="comment" onClick={() => this.setState({
                isAddCommentOpened: true,
                currentAddCommentIndex: index,
                editingCommentIndex: i,
                editingComment: c
              })}>
                <p>
                  {c.comment}
                  <br />
                  <b>{(new Date(c.date)).toLocaleDateString()}</b>
                </p>

              </div>
            ))
            }
          </Fragment>
        ))
    }
  }

  addComments(data) {
    let referenceResponses = this.props.taskGroup.reference_responses || {}
    let comments = referenceResponses[`C${this.state.currentAddCommentIndex}`] || []
    if(this.state.editingCommentIndex !== null) {
      this.props.onReferenceMaterialUpdate(`C${this.state.currentAddCommentIndex}`, comments.map((c,i) => {
        if(i !== this.state.editingCommentIndex) {
          return c;
        }
        return data
      }))
    } else {
      this.props.onReferenceMaterialUpdate(`C${this.state.currentAddCommentIndex}`, [...comments, data])
    }
    this.setState({
      isAddCommentOpened: false,
      currentAddCommentIndex: null,
      editingCommentIndex: null,
      editingComment: null
    })
  }

  subGroupTasks(subGroup) {
    return subGroup.tasks.sort((a, b) => {
      if (!a.prompt.match(/^\d/) && !b.prompt.match(/^\d/)) {
        return 0;
      }
      return collator.compare(a.prompt, b.prompt)
    });
  }

  get tasks() {
    return this.props.taskGroup.tasks.sort((a, b) => {
      if (!a.prompt.match(/^\d/) && !b.prompt.match(/^\d/)) {
        return 0;
      }
      return collator.compare(a.prompt, b.prompt)
    });
  }



  render() {

    let {
      taskGroup,
      onSaveResponse,
      onSubmitResponse,
      onTaskCardClick,
      onExpandAllClick,
      onCollapsellClick,
      onEditResponse,
      onCancelEditResponse,
      onReferenceMaterialUpdate,
      isLoading,
      editingResponse,
      canAdd,
      canAck,
      oitShortLabel,
      ftoShortLabel,
      canAddOrEdit,
      onRejectResponse
    } = this.props

    return (
      <div className="task-group-training-details">
        <div className="task-group-training-details-actions">
          <button className="button secondary small" onClick={() => window.print()}>
            <i className="fa fa-print"/>
            <span>Print</span>
          </button>
          <button className="button secondary small" onClick={() => onExpandAllClick(this.tasks)}>
            <i className="fa fa-angle-down"/>
            <span>Expand All</span>
          </button>
          <button className="button secondary small" onClick={() => onCollapsellClick(this.tasks)}>
            <i className="fa fa-angle-up"/>
            <span>Collapse All</span>
          </button>
        </div>

        {this.props.taskGroup.subGroups && this.props.taskGroup.subGroups.map(sg => (
          <div key={sg.guid}>
            <h3 style={{
              padding: '20px'
            }} className="subgroup-title">{sg.name}</h3>
            {this.subGroupTasks(sg).map(task => (
              <Card key={task.taskGuid}>
                <div className="task-training-response" key={task.taskGuid}>
                  <TaskResponseHeader
                    task={task}
                    onTaskResponseHeaderClick={(task) => onTaskCardClick(task)}
                    canAddOrEdit={canAddOrEdit}
                  />

                  <Collapse isOpen={task.toggleAccordion}>
                    <CardBody>
                      <TaskResponseRow
                        task={task}
                        taskGroup={taskGroup}
                        editingResponse={editingResponse}
                        ftoShortLabel={ftoShortLabel}
                        canAddOrEdit={canAddOrEdit}
                        isLoading={isLoading}
                        oitShortLabel={oitShortLabel}
                        onEditResponse={onEditResponse}
                        onSubmitResponse={(data) => onSubmitResponse(data)}
                        onRejectResponse={(data) => onRejectResponse(data)}
                        onCancelEditResponse={onCancelEditResponse}
                        onSaveResponse={onSaveResponse}
                        refresh={(task) => onTaskCardClick(task)}   // this is also needed to refresh the open state in the TaskResponseRow
                      />

                      {canAddOrEdit && (
                        <TaskResponseForm
                          isLoading={isLoading}
                          onSaveResponse={(data) => onSaveResponse(data)}
                          cancelEditResponse={() => onCancelEditResponse()}
                          editingResponse={editingResponse}
                          task={task}/>
                      )}
                    </CardBody>
                  </Collapse>
                </div>
              </Card>
            ))}

            {sg.description &&
              <div className="refrence-material">
                <label>Reference Material</label>
                <div className="content">
                  {this.getReferenceMaterialSplit(sg.description, sg)}
                </div>
              </div>
            }

          </div>
        ))}

        {this.tasks.map(task => (
          <Card key={task.taskGuid}>
            <div className="task-training-response" key={task.taskGuid}>
              <TaskResponseHeader
                task={task}
                onTaskResponseHeaderClick={(task) => onTaskCardClick(task)}
                canAddOrEdit={canAddOrEdit}
              />

              <Collapse isOpen={task.toggleAccordion}>
                <CardBody>
                  <TaskResponseRow
                    task={task}
                    taskGroup={taskGroup}
                    editingResponse={editingResponse}
                    ftoShortLabel={ftoShortLabel}
                    canAddOrEdit={canAddOrEdit}
                    isLoading={isLoading}
                    oitShortLabel={oitShortLabel}
                    onEditResponse={onEditResponse}
                    onSubmitResponse={(data) => onSubmitResponse(data)}
                    onRejectResponse={(data) => onRejectResponse(data)}
                    onCancelEditResponse={onCancelEditResponse}
                    onSaveResponse={onSaveResponse}
                    refresh={(task) => onTaskCardClick(task)}   // this is also needed to refresh the open state in the TaskResponseRow
                  />

                  {canAddOrEdit && (
                    <TaskResponseForm
                      isLoading={isLoading}
                      onSaveResponse={(data) => onSaveResponse(data)}
                      cancelEditResponse={() => onCancelEditResponse()}
                      editingResponse={editingResponse}
                      task={task}/>
                  )}
                </CardBody>
              </Collapse>
            </div>
          </Card>
        ))}

        {taskGroup.description &&
        <div className="refrence-material">
          <label>Reference Material</label>
          <div className="content">
            {this.getReferenceMaterialSplit(taskGroup.description, taskGroup)}
          </div>
        </div>
        }


        <Modal
          title="Add comment/note"
          isOpen={this.state.isAddCommentOpened}
          onClose={() => this.setState({isAddCommentOpened: false})}
        >
          {this.state.isAddCommentOpened && (
            <CustomForm
              config={taskAddCommentForm}
              initialValues={this.state.editingComment}
              onSubmit={(data) => this.addComments(data)}
            />
          )}
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
  }
};

export default connect(mapStateToProps)(TaskGroupTrainingDetails);
